export default {
    ThreePartySalesOrder: {
        Channel: 'Channel',
        Store: 'Store',
        After: 'After-sales type',
        Platform: 'Platform status',
        Internal: 'CSG Order No.',
        order: 'Internal Order No./after-sales Order No.',
        Tripartite: 'Customer Order No.',
        Third: 'Third-party after-sales Order No. / Customer Order No./Third-party exchange Order No.',
        Return: 'Return logistics',
        logistics: 'Return logistics Order No.',
        Circulation: 'Product flow status',
        sales: 'After-sales phase',
        reasons: 'Platform after-sales reason',
        nickname: 'Buyer nickname',
        Application: 'Application for after-sales time',
        Refund: 'Refund success time',
        Timeout: 'Timeout',
        Creation: 'Creation time',
        Add: 'Add third-party after-sales order',
        push: 'Push',
        confirmation: 'Reprocess',
        ReleaseHold: 'Release Hold',
        HoldOrder: 'Hold Order',
        OnHold: 'On Hold',
        OnHoldStatus:'On Hold',
        Manually: 'Manually download authorized store orders',
        download: 'Manually download authorized store orders (by Order No.)',
        authorized: 'Manually download authorized store orders (by time)',
        Online: 'Online Order No. (one Order No. per line, up to 100)',
        Please: 'Please select exception order',
        selectDataWarning: 'Select at least one piece of data!',
        selectDataWarning1: 'Select up to 200 pieces of data!',
        selectDataWarning2: 'Select at least one piece of Relevant Categories data!',
        selectDataWarning3: 'The selected order is completed or already cancelled and cannot be cancelled again.',
        msgError: 'The file has been submitted. Click Import History to view the import result',
        msgError1: 'The selected items are already inactive and cannot be set to inactive again.',
        form: {
            number: 'Third-party after-sales Order No.',
            Reason: 'Reason for abnormal processing',
            Aftersales: 'After-sales return status',
            Customer: 'Customer service intervention',
            Transaction: 'Transaction amount',
            Refund: 'Refund amount',
            quantity: 'Refund quantity',
            Remarks: 'Remarks',
            Original: 'Original order receiving address',
            After: 'After-sales completion time',
            time: 'Modification time',
            Creation: 'Creation time',
            Timeout: 'Timeout',
            Operator: 'Operator',
            Third: 'Third-party exchange Order No.',
            Shipping: 'Dispatching logistics',
            Issue: 'Job Id/Tracking No.',
            logistics: 'Synchronized logistics status',
            failure: 'Reason for logistics synchronization failure',
            refundMethod: 'Refund Method',
            isExport: 'Export Status'
        }
    }
};
